import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { appStatus } from 'src/app/+state/app/app.selectors';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-sidenav-content',
    standalone: true,
    imports: [
    RouterModule,
    MatListModule,
    MatDividerModule,
    MatIconModule,
    TranslateModule
],
    templateUrl: './sidenav-content.component.html',
    styleUrls: ['./sidenav-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavContentComponent {
  appStatus = toSignal(this.store.select(appStatus));

  constructor(
    private store: Store<any>,
  ) {}
}
